export const en: {
  nav: { soon: string };
  hero: {
    eyebrow: string;
    headlineLine1: string;
    headlineLine2: string;
    lead: string;
    ctaNote: string;
  };
  mock: {
    from: string;
    sortCost: string;
    sortDate: string;
    bestValue: string;
    allIn: string;
  };
  problem: {
    eyebrow: string;
    heading: string;
    body1: string;
    body2: string;
    realCost: string;
    returnLeg: string;
    crewMessage: string;
    yourWeekend: string;
    sorted: string;
    flights: string;
    stay: string;
    race: string;
    allIn: string;
  };
  discovery: {
    eyebrow: string;
    heading: string;
    lead: string;
    feat1Kicker: string;
    feat1Heading: string;
    feat1Body: string;
    feat2Kicker: string;
    feat2Heading: string;
    feat2Body: string;
    feat3Kicker: string;
    feat3Heading: string;
    feat3Body: string;
  };
  twoJobs: {
    eyebrow: string;
    heading: string;
    freeTag: string;
    freeHeading: string;
    freeBody: string;
    paidTag: string;
    paidHeading: string;
    paidBody: string;
  };
  payoff: {
    eyebrow: string;
    heading: string;
    body1: string;
    body2: string;
    cardDay: string;
    leaveHotel: string;
    leaveHotelSub: string;
    coffee: string;
    coffeeSub: string;
    raceStart: string;
    postRace: string;
    postRaceSub: string;
  };
  who: { eyebrow: string; heading: string; lead: string };
  pricing: {
    eyebrow: string;
    heading: string;
    freeTier: string;
    freeAmount: string;
    freeCadence: string;
    freeDesc: string;
    freeItem1: string;
    freeItem2: string;
    freeItem3: string;
    perTripTier: string;
    perTripBadge: string;
    perTripAmount: string;
    perTripCadence: string;
    perTripDesc: string;
    perTripItem1: string;
    perTripItem2: string;
    perTripItem3: string;
    seasonTier: string;
    seasonBadge: string;
    seasonAmount: string;
    seasonCadence: string;
    seasonDesc: string;
    seasonItem1: string;
    seasonItem2: string;
    seasonItem3: string;
  };
  final: { heading: string; lead: string };
  footer: { privacy: string; terms: string; contact: string };
  seo: { title: string; description: string };
} = {
  nav: {
    soon: 'Launching soon',
  },
  hero: {
    eyebrow: 'For racers who travel',
    headlineLine1: 'You focus on the race.',
    headlineLine2: 'We’ll handle the plan.',
    lead: 'The race is three hours. The weekend around it — the right hotels, the transfers, the food, the flight home — is three weeks of tabs. You did the hard part already; we’ll do the rest.',
    ctaNote: 'Free · no card',
  },
  mock: {
    from: 'From',
    sortCost: 'All-in cost',
    sortDate: 'Date',
    bestValue: 'Best value',
    allIn: 'all-in',
  },
  problem: {
    eyebrow: 'The weekend, not the race',
    heading: 'The race is never where the name says.',
    body1:
      'First you work out whether you can even afford it — the entry’s the easy bit; it’s the flights, the hotels and everything else that decides if the trip happens at all. Say it does.',
    body2:
      'Then the venue turns out to be an hour outside the city. So it’s a hotel near the start, another back in town to recover, trains you’ve never taken, dinner to find twice, and a flight home you have to back-time from. None of it is the race — and all of it lands on you.',
    realCost: 'Real cost?',
    returnLeg: 'Return leg',
    crewMessage: '“where do we stay??”',
    yourWeekend: 'Your weekend',
    sorted: 'Sorted',
    flights: 'Flights',
    stay: 'Stay · 2 nts',
    race: 'Race · Beast',
    allIn: 'All-in',
  },
  discovery: {
    eyebrow: 'What it does',
    heading: 'We price the whole trip, before you commit.',
    lead: 'Tell us where you start. RaceAtlas ranks every race by what it’ll actually cost you — door to door — entry, flights or drive, and a place to stay. Honest ranges, a confidence rating on every number, the cheapest worth-it race at the top.',
    feat1Kicker: 'Honest numbers',
    feat1Heading: 'A confidence rating on every cost',
    feat1Body:
      'Entry, travel, stay — each line says how much real data backs it. No false precision, ever.',
    feat2Kicker: 'From your door',
    feat2Heading: 'Drive or fly, decided for you',
    feat2Body:
      'We work out whether you’d drive or fly from your home — and rank the all-in cost accordingly.',
    feat3Kicker: 'Worth-it first',
    feat3Heading: 'Ranked, not just listed',
    feat3Body:
      'The cheapest race you’d actually want is at the top. Re-rank by date or reach in a tap.',
  },
  twoJobs: {
    eyebrow: 'Free vs paid',
    heading: 'Free tells you what it costs. €9.99 tells you what to do.',
    freeTag: 'Free · a tool',
    freeHeading: 'Know what it costs',
    freeBody:
      'Search, rank and compare every race by real all-in cost from home. Save your shortlist. Unlimited, forever.',
    paidTag: '€9.99 · a service',
    paidHeading: 'Know what to do',
    paidBody:
      'A race-weekend plan that decides for you — race-morning timings, parking and bag-drop, and the coffee and dinner already picked, on your route, to your diet.',
  },
  payoff: {
    eyebrow: 'The €9.99 itinerary',
    heading: 'Like a friend who’s done the race.',
    body1:
      'A friend doesn’t hand you a list of eight cafés — they tell you where to go. So do we: the coffee on your way to the start, the post-race dinner that fits your diet, the exact minute to leave so you don’t miss bag-drop. Already chosen, with the reason shown. Change anything in a tap.',
    body2:
      'It knows the course, the wave times, the parking, the drive. The stuff you’d only learn the hard way — the second time.',
    cardDay: 'Sat 23 Aug · race day',
    leaveHotel: 'Leave hotel',
    leaveHotelSub: '15 min · parking opens 07:00',
    coffee: 'Coffee · Bar Nuovo',
    coffeeSub: 'on your route · +6 min · opens 06:30',
    raceStart: 'Race start · Beast',
    postRace: 'Post-race meal · Sa Tanca',
    postRaceSub: 'vegetarian · +3 min on the way back',
  },
  who: {
    eyebrow: 'Who it’s for',
    heading: 'Built for racers who travel for races.',
    lead: 'Competitive endurance athletes doing 5 to 15 events a year — Spartan plus Hyrox plus a UTMB stage plus a Tough Mudder is a normal calendar. If you race once a year, the free tier is all you need. If you’re planning multiple weekends abroad and want it to feel less like work — that’s us.',
  },
  pricing: {
    eyebrow: 'Pricing',
    heading: 'Free to decide. Pay for the part you can’t get anywhere else.',
    freeTier: 'Free',
    freeAmount: '€0',
    freeCadence: 'forever',
    freeDesc: 'Rank every race by real cost, from your door. Save a shortlist.',
    freeItem1: 'Unlimited search & cost ranking',
    freeItem2: 'Up to 3 saved plans',
    freeItem3: 'Calendar + reminders',
    perTripTier: 'Per trip',
    perTripBadge: 'The product',
    perTripAmount: '€9.99',
    perTripCadence: 'one-off per race',
    perTripDesc: 'The race weekend, planned and decided — like a friend who’s done it.',
    perTripItem1: 'Race-morning timeline + parking',
    perTripItem2: 'Coffee, meals & recovery, pre-picked',
    perTripItem3: 'Shareable · refundable for 7 days',
    seasonTier: 'Season pass',
    seasonBadge: 'Soon',
    seasonAmount: '€45',
    seasonCadence: 'per year',
    seasonDesc: 'For 8+ races a year. Your whole season, unlimited, in one place.',
    seasonItem1: 'Every itinerary included',
    seasonItem2: 'Season spend, budget & clashes',
    seasonItem3: 'Booking timing (post-launch)',
  },
  final: {
    heading: 'You focus on the race.',
    lead: 'We’ll handle the rest — what it costs, where you stay, how you get there, what to do when you land. Free to start, no card.',
  },
  footer: {
    privacy: 'Privacy',
    terms: 'Terms',
    contact: 'Contact',
  },
  seo: {
    title: 'Race Atlas — You focus on the race, we’ll handle the plan',
    description:
      'Race Atlas plans your race weekends end to end — what they really cost, where to stay, how to get there, and what to do when you land. You focus on the race; we’ll handle the plan.',
  },
};

export type Messages = typeof en;
